import React from "react";
import classNames from "classnames";
import { useTranslation } from "react-i18next";
import { useRolesRetrieval } from "@planzone/view-models";
import { SelectList } from "@common/selectList";
import { SelectedIcon } from "@common/selectedIcon";
import { Props } from "./types";
import { ArrowIcon } from "./arrowIcon";
import styles from "./styles.scss";

function RoleSelection(props: Props) {
  const { t } = useTranslation();
  const { roles } = useRolesRetrieval();

  React.useEffect(() => {
    !props.selectedRole &&
      roles.forEach((role) => role.name === "pr_worker" && props.select(role));
  }, []);

  return (
    <div>
      <SelectList listClassName={styles.list}>
        {({ isOpen, select }) => ({
          input: (
            <div className={styles.roleSelection}>
              <div
                className={classNames(
                  { [styles.input]: !isOpen },
                  { [styles.inputOpened]: isOpen },
                )}
              >
                {props.selectedRole ? (
                  <p className={styles.selection}>
                    {t(
                      `roles.${props.selectedRole.name}`,
                      props.selectedRole.name,
                    )}
                  </p>
                ) : (
                  <p
                    className={classNames(styles.selection, styles.placeholder)}
                  >
                    {props.placeholder}
                  </p>
                )}
                <div className={styles.iconBox}>
                  <ArrowIcon
                    className={classNames(
                      { [styles.icon]: !isOpen },
                      { [styles.iconReverse]: isOpen },
                    )}
                  />
                </div>
              </div>
            </div>
          ),
          list: (
            <div className={styles.menu}>
              {roles
                .filter(({ name }) => name.slice(0, "pr".length) === "pr")
                .map((role) => (
                  <div
                    key={role.uuid}
                    className={styles.role}
                    onClick={() => {
                      select(props.select(role));
                    }}
                  >
                    {props.selectedRole &&
                    props.selectedRole.name === role.name ? (
                      <div className={styles.selectedRole}>
                        <div className={styles.selectedRoleTitle}>
                          {t(`roles.${role.name}`, role.name)}{" "}
                          <SelectedIcon className={styles.selectedRoleIcon} />
                        </div>
                      </div>
                    ) : (
                      <div>{t(`roles.${role.name}`, role.name)}</div>
                    )}
                    <div className={styles.roleDescription}>
                      {t(`roles.description.${role.name}`, role.name)}
                    </div>
                  </div>
                ))}
            </div>
          ),
        })}
      </SelectList>
    </div>
  );
}

export { RoleSelection };
